/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { Img } from 'react-image';

import { makeStyles } from '@material-ui/core/styles';
import {
  Fade, Box, Grid, AppBar,
} from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import { styles, StyledTabs, StyledTab } from '../style';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const classes = useStyles();
  const {
    children, value, index, ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.contentImg}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `forecast_rain_animation_tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

export default function ForecastRainfallAnimationDataLists() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [hasError, sethasError] = useState();

  const hostApi = `${process.env.REACT_APP_API_URL}`;
  const [rainanimation, setRainanimation] = useState([{}, {}, {}, {}]);
  const placeHolder = 'https://via.placeholder.com/322x230?text=No%20Video&italic=true';

  useEffect(() => {
    function getData() {
      fetch(`${hostApi}/public/rain7day_forecast`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          setRainanimation([...data.data.pre_rain_animation.data]);
        })
        .catch(() => { sethasError(true); });
    }
    getData();
  }, [hostApi]);

  useEffect(() => {
    if (rainanimation.length === 4) {
      rainanimation.splice(2, 1);
    }
  }, [rainanimation, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      <div className={classes.root}>

        <AppBar position="static" color="inherit" className={classes.tabStyle}>
          <StyledTabs position="static" value={value} onChange={handleChange} scrollButtons="auto" variant="scrollable" aria-labelledby="simple tabs example" textColor="secondary" indicatorColor="secondary">
            <StyledTab
              icon={<PlayArrowIcon />}
              label={<Box>Asia (27km x 27km)</Box>}
              {...a11yProps(0)}
            />
            <StyledTab
              icon={<PlayArrowIcon />}
              label={<Box>Southeast Asia (9km x 9km)</Box>}
              {...a11yProps(1)}
            />
            <StyledTab
              icon={<PlayArrowIcon />}
              label={<Box>Thailand (3km x 3km)</Box>}
              {...a11yProps(2)}
            />
          </StyledTabs>
        </AppBar>

        <Grid container>
          <Grid item md className={classes.bodyAnimationBox}>
            {rainanimation.slice(0, 3).map((img, i) => {
              let toshow = '';
              if (img.media_path === undefined || img.media_path === '') {
                toshow = (
                  <Grid container spacing={3} justifyContent="center">
                    <Grid item>
                      <Box display="block">
                        <Box><Img src={placeHolder} alt="onwr" className={classes.img} /></Box>
                      </Box>
                    </Grid>
                  </Grid>
                );
              } else {
                toshow = (
                  <Grid container spacing={3} justifyContent="center">
                    <Fade in>
                      <Grid item>
                        <Box display="block">
                          <Box>
                            <video muted controls autoPlay width="100%">
                              <source src={`${hostApi}/shared/image?_csrf=&image=${rainanimation[i].media_path}`} type="video/mp4" />
                            </video>
                          </Box>
                        </Box>
                      </Grid>
                    </Fade>
                  </Grid>
                );
              }
              return (
                <TabPanel value={value} index={i} key={uniqueId()}>
                  {toshow}
                </TabPanel>
              );
            })}
          </Grid>
        </Grid>
      </div>
    </>
  );
}
